import React from 'react';
import { QrCode } from 'lucide-react';

const ReraImageBadge = ({
  number,
  onClick,
  compact = false,
  className = '',
  testId,
}) => {
  if (!number) return null;

  const content = (
    <>
      <span
        className={`${compact ? 'h-6 w-6 rounded-md' : 'h-7 w-7 rounded-lg'} flex flex-none items-center justify-center bg-white/15`}
        aria-hidden="true"
      >
        <QrCode className={compact ? 'h-3.5 w-3.5' : 'h-4 w-4'} strokeWidth={2.2} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-[9px] font-black uppercase leading-none text-white">RERA</span>
        <span
          className={`${compact ? 'text-[9px]' : 'text-[10px]'} mt-0.5 block line-clamp-2 break-all font-extrabold leading-[1.15] text-white`}
        >
          {number}
        </span>
        <span className="mt-0.5 block truncate text-[9px] font-semibold leading-none text-white/75">
          rera.kerala.gov.in
        </span>
      </span>
    </>
  );

  const classes = [
    'inline-flex min-h-12 items-center gap-2 rounded-xl border border-white/35',
    'bg-[rgba(9,10,20,0.68)] px-2 py-1.5 text-left text-white',
    'shadow-lg shadow-black/20 backdrop-blur-md',
    className,
  ].join(' ');

  if (onClick) {
    return (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          onClick(event);
        }}
        className={`${classes} transition-colors hover:bg-[rgba(9,10,20,0.78)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80`}
        aria-label={`View RERA details for ${number}`}
        title={`RERA ${number}`}
        data-testid={testId}
      >
        {content}
      </button>
    );
  }

  return (
    <div
      className={classes}
      role="note"
      aria-label={`RERA registered: ${number}`}
      title={`RERA ${number}`}
      data-testid={testId}
    >
      {content}
    </div>
  );
};

export default ReraImageBadge;
